import { render, staticRenderFns } from "./Carousel2.vue?vue&type=template&id=de53c482&scoped=true&"
import script from "./Carousel2.vue?vue&type=script&lang=js&"
export * from "./Carousel2.vue?vue&type=script&lang=js&"
import style0 from "./Carousel2.vue?vue&type=style&index=0&id=de53c482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de53c482",
  null
  
)

export default component.exports